import React from "react";
import { Table } from "react-bootstrap";

import { Skeleton } from "components";
import { useLoader } from "hooks";
import { feesModel, pricingMethods } from "models";
import { float4Normalizer } from "validators";

import styles from "./scheduleAView.module.scss";

type FeesViewBlockProps = {
	feesData: { [key: string]: any } | undefined;
	isLoading: boolean;
};

export const FeesViewBlock = ({ feesData, isLoading }: FeesViewBlockProps) => {
	const Loader = useLoader(isLoading);

	const getCellValue = value => {
		const result = value === null || value === undefined ? "-" : value;
		return (
			<Loader
				skeleton={<Skeleton width={90} variant="text" />}
				component={result}
			/>
		);
	};

	return (
		<div className={styles.tableWrapper}>
			<Table hover borderless>
				<thead className="text-nowrap">
					<tr>
						<th>Pricing Element</th>
						<th>Pricing Method</th>
						<th>Rate, %</th>
						<th>Per Item Fee, $</th>
						<th>Revenue Share, %</th>
						<th>Calculation</th>
					</tr>
				</thead>
				<tbody>
					{feesModel.map(
						({ feeLabel, feeName, calculationLabel }, key) => {
							const pricingMethod =
								Object.values(pricingMethods).find(
									({ value }) =>
										value ===
										feesData?.fees[feeName]?.pricing_method,
								) ?? pricingMethods.passThrough; // SDI-105: set by default if not found

							return (
								<tr key={key}>
									<td>{feeLabel}</td>
									<td>
										{getCellValue(pricingMethod?.label)}
									</td>
									<td className="text-center">
										{getCellValue(
											float4Normalizer(
												feesData?.fees[feeName]?.rate,
											),
										)}
									</td>
									<td className="text-center">
										{getCellValue(
											float4Normalizer(
												feesData?.fees[feeName]
													?.per_item_fee,
											),
										)}
									</td>
									<td className="text-center">
										{getCellValue(
											feesData?.fees[feeName]
												?.revenue_share,
										)}
									</td>
									<td>{calculationLabel}</td>
								</tr>
							);
						},
					)}
				</tbody>
			</Table>
		</div>
	);
};
